/* eslint-disable */

import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import { useRouter } from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  CanBoCongChucBienDongGetAllBienDongVaNghiViecOfDonVi as getList,
  GetBienDongDi,
  GetBienDongDen,
} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucBienDongService";

import {
  GetCanBoCongChucNghiViec,
  GetCanBoCongChucDaXoa,
  GetCanBoCongChucKhoiDang
} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

import { GetTree } from "@/services/api/DefaultTemplate/DonViService";

import { unGroupList } from "@/userlibs/globalLibs";

export default function useDonViService() {
  const perPage = ref(10);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const toast = useToast();
  const { route, router } = useRouter();
  const getDataBienDongDi = (ctx, callback) => {
    GetBienDongDi(ctx).then((response) => {
      if (!response.isError) {
        // data.bienDongDi = response.data;
        callback(response.data);
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };

  const getDataBienDongDen = (ctx, callback) => {
    GetBienDongDen(ctx).then((response) => {
      if (!response.isError) {
        // data.bienDongDen = response.data;
        callback(response.data);
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };
  const getDataNghiViec = (ctx, callback) => {
    GetCanBoCongChucNghiViec(ctx).then((response) => {
      if (!response.isError) {
        // data.nghiViec = response.data;
        callback(response.data);
      } else {
        callback(null);
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };
  const getDataDaXoa = (ctx, callback) => {
    GetCanBoCongChucDaXoa(ctx).then((response) => {
      if (!response.isError) {
        // data.nghiViec = response.data;
        callback(response.data);
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };
  const getDataKhoiDang = (ctx, callback) => {
    GetCanBoCongChucKhoiDang(ctx).then((response) => {
      if (!response.isError) {
        // data.nghiViec = response.data;
        callback(response.data);
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };
  // const getDataList = (ctx, callback) => {
  //   const data = {};
  //   GetBienDongDi(ctx).then((response) => {
  //     if (!response.isError) {
  //       data.bienDongDi = response.data;
  //       callback(data);
  //     } else {
  //       toast({
  //         component: ToastificationContent,
  //         props: {
  //           title: "Thất bại",
  //           icon: "AlertTriangleIcon",
  //           variant: "danger",
  //           text: response.message,
  //         },
  //       });
  //     }
  //   });
  //   GetBienDongDen(ctx).then((response) => {
  //     if (!response.isError) {
  //       data.bienDongDen = response.data;
  //       callback(data);
  //     } else {
  //       toast({
  //         component: ToastificationContent,
  //         props: {
  //           title: "Thất bại",
  //           icon: "AlertTriangleIcon",
  //           variant: "danger",
  //           text: response.message,
  //         },
  //       });
  //     }
  //   });
  //   GetNghiViec(ctx).then((response) => {
  //     if (!response.isError) {
  //       data.nghiViec = response.data;
  //       // callback(response.data);
  //       callback(data);
  //     } else {
  //       toast({
  //         component: ToastificationContent,
  //         props: {
  //           title: "Thất bại",
  //           icon: "AlertTriangleIcon",
  //           variant: "danger",
  //           text: response.message,
  //         },
  //       });
  //     }
  //   });
  // };

  const getDonVi = (ctx, callback) => {
    GetTree().then((response) => {
      if (response.data.length < 1) {
        router.replace("/").then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error: Go To Home page",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: "Chức năng bị hạn chế",
            },
          });
        });
      }
      callback(response.data);
      // donVis.value = response.data;
    });
  };

  // const { donVis } = GetUserOtherData();
  // if (donVis.length < 1) {
  //   router.replace("/").then(() => {
  //     toast({
  //       component: ToastificationContent,
  //       props: {
  //         title: "Error: Go To Home page",
  //         icon: "AlertTriangleIcon",
  //         variant: "danger",
  //         text: "Chức năng bị hạn chế",
  //       },
  //     });
  //   });
  // }

  //phong ban
  const loadPhongBan = (pams, callback) => {
    store.dispatch("donvi/fetchListDonVi", pams).then((response) => {
      var listLevel = JSON.parse(JSON.stringify(response));
      var resList = unGroupList(listLevel, "detailChilds");
      callback(resList);
    });
  };

  return {
    // getDataList,
    getDataBienDongDi,
    getDataBienDongDen,
    getDataNghiViec,
    getDataDaXoa,
    getDataKhoiDang,
    // donVis,
    getDonVi,

    loadPhongBan,
    perPage,
    currentPage,
    perPageOptions,
  };
}
